import { getCurrentDevice, $win, $doc } from './utils';

import currentYear from './current-year';
import adaUI from './ada';
import readMoreUI from './read-more-ui';
import headerUI from './header-ui';
import personalizationUI from './modules/personalizationUI';
import initBookingMask from './BookingMask';
import cookiesUI from './cookie';
import scrollUI from './scroll.js';

import initJSONStatic from './modules/json-static-block';

import ReadMore from "./read-more.js";
import { initCmsGridList } from './helpers.js';

(function(window, document, $) {
	initJSONStatic({
		callback(el) {
			if (el.querySelectorAll('.js-custom-select').length) {
				import(/* webpackChunkName: "select" */ './select.js').then(module => {
					module.default(el);
				});
			}
		}
	});

	$('.js-move').each(function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.append($this);
	});

	const bookTable = () => {
		const $button = $('.js-restaurant-trigger');

		$('.js-restaurant').on('change', function() {
			const $this = $(this);
			const value = $this.val();

			if (value) {
				$button.removeAttr('disabled');
				$button.attr('data-target', value);
			} else {
				$button.attr('disabled', true);
			}
		})
	}

	const redirectRFP = () => {
		const $form = $('#booking-tab-enquiry').find('form');
		const $firstName = $form.find('#event_first_name');
		const $lastName = $form.find('#event_last_name');
		const $email = $form.find('#event_email');
		const $phone = $form.find('#event_phone');

		$form.on('submit', function(e) {
			$(this).trigger('GalaxyEventForm');
			localStorage.firstname = $firstName.val();
			localStorage.lastname = $lastName.val();
			localStorage.email = $email.val();
			localStorage.phone = $phone.val();

			console.log('is working', $firstName.val(), $lastName.val(), $email.val(), $phone.val())
		});

		const $firstNameRFP = $('.form-rfp').find('.firstname');
		const $lastNameRFP = $('.form-rfp').find('.lastname');
		const $emailRFP = $('.form-rfp').find('.email');
		const $phoneRFP = $('.form-rfp').find('.phone');

		if ($('.form-rfp').length) {
			$firstNameRFP.val(localStorage.firstname);
			$lastNameRFP.val(localStorage.lastname);
			$emailRFP.val(localStorage.email);
			$phoneRFP.val(localStorage.phone);
		}
	}

	$('.js-toggle').on('click', function() {
		const $target = $($(this).data('target'));

		$target.toggleClass('active')
	})

	$('.js-toggle-menus').on('click', function(event) {
		event.preventDefault();

		$(this).parents('.has-accordion').toggleClass('active');
	});

	$('a[href^="tel"]').each(function() {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-trim-decimals').each(function() {
		const number = Math.trunc($(this).text());

		$(this).text(number);
	});

	$('.js-add-commas').each(function() {
		const number = $(this).text();
		const length = number.length;

		if ( length > 3 ) {
			$(this).text(number.slice(0, length - 3) + ',' + number.slice(length - 3,length));
		}
	});

	if ($('.js-date').length) {
		import(/* webpackChunkName: "date-ui" */ './date-ui.js').then(module => {
			module.default();
		});
	}

	$('.js-trim-decimals').each(function() {
		const number = Math.trunc($(this).text());

		$(this).text(number);
	});

	$('.js-show-more').on('click', function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$this.toggleClass('active');
		$target.toggleClass('expanded');
	});

	$('.js-map-image').on('click', function() {
		$(this).addClass('d-none');
	});

	import(/* webpackChunkName: "fullsize" */ './fullsize.js').then(module => {
		module.default();
	});

	if ($('.js-slider-images').length || $('.js-slider-experiences').length) {
		import(/* webpackChunkName: "sliders" */ './sliders.js').then(module => {
			module.default();
		});
	}

	if ($('.js-filter-container').length) {
		import(/* webpackChunkName: "filtersUI" */ './filtersUI.js').then(module => {
			module.default();
		});
	}

	if ( $('.js-gallery').length ) {
		import(/* webpackChunkName: "gallery" */ './gallery.js').then(module => {
			module.default();
		});
	}

	adaUI();

	cookiesUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	readMoreUI();

	if ($('.map').length) {
		import(/* webpackChunkName: "maps-ui" */ './maps-ui.js').then(module => {
			module.default();
		});
	}

	if ($('.js-form').length) {
		import(/* webpackChunkName: "forms-ui" */ './forms-ui.js').then(module => {
			module.default();
		});
	}

	headerUI();

	if ($('.js-filter-pagination').length) {
		import(/* webpackChunkName: "filter-pagination" */ './filter-pagination.js').then(module => {
			module.default();
		});
	}

	import(/* webpackChunkName: "booking-ui" */ './booking-ui.js').then(module => {
		module.default();
	});

	if ($('.rooms').length) {
		import(/* webpackChunkName: "rooms-ui" */ './rooms-ui.js').then(module => {
			module.default();
		});
	}

	if ($('.js-custom-select').length) {
		import(/* webpackChunkName: "select" */ './select.js').then(module => {
			module.default();
		});
	}

	redirectRFP();

	const hindeSocials = () => {
		const $footer = $('.footer');
		const $socials = $('.socials-sticky ul');
		const $footerSocials = $('.footer__socials');
		const socialsHeight = $socials.outerHeight();
		const socialsFooterHeight = $footerSocials.outerHeight();

		$win.on('scroll', function() {
			if ($win.scrollTop() + ($win.height()/2) + socialsHeight > $footer.offset().top + socialsFooterHeight) {
				$('.socials-sticky').addClass('d-none');
			} else {
				$('.socials-sticky').removeClass('d-none');
			}
		});
	}

	hindeSocials();


	personalizationUI();

	initBookingMask();

	bookTable();

	window.addEventListener('DOMContentLoaded', () => {
		if (document.querySelectorAll('[data-shave]').length) {
			import(/* webpackChunkName: "shave-ui" */ './shave-ui.js').then(module => {
				module.default();
			});
		}
	});

	scrollUI();

	//Initializing CMS Grid List 
	initCmsGridList()


	/**
	 * COMMOM READ MORE INITIALIZATION
	 * 
	 * Initializes the 'Read More' functionality for section elements 
	 * with the 'has-readmore' class.
	 * Only use this if you need basic functionality.
	 * If you need more controll, Initialize "Read-More" for that block seperately.
	 * 
	 * Read More Section Class 					: has-readmore
	 * WYSIWYG Element Class 						: read-more-wysiwyg
	 * Read More Button Element Class 	: readmore-btn
	 */

	document.querySelectorAll(".has-readmore").forEach(sectionEl=>{
		const wysiwygEl = sectionEl.querySelector(".read-more-wysiwyg")
		const buttonEl = sectionEl.querySelector(".readmore-btn")
		const rdMore = new ReadMore({
		sectionEl: sectionEl,
		wysiwygEl: wysiwygEl,
		buttonEl: buttonEl,
		animation: 0.3,
		})
	})

})(window, document, window.jQuery);
